import { DialogComponent } from '@theme/dialog';

/**
 * Waitlist button dialog that reopens after a Shopify customer form POST.
 *
 * @extends DialogComponent
 */
class WaitlistButtonDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    if (!this.querySelector('[data-waitlist-reopen]')) return;

    // Wait a paint so the open animation runs after page load.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.showDialog());
    });
  }
}

if (!customElements.get('waitlist-button-dialog')) {
  customElements.define('waitlist-button-dialog', WaitlistButtonDialog);
}
